import { useScrollAnimation } from '../hooks/useScrollAnimation';

const painCards = [
  {
    icon: 'ri-alarm-warning-line',
    iconBg: 'bg-red-50',
    iconColor: 'text-coral',
    title: 'Leads esfriando na fila',
    text: 'Seu cliente manda mensagem pedindo preço de um equipamento de R$15 mil. Seu time demora 2 horas pra responder. Quando responde, ele já fechou com o concorrente.',
    stat: '2h',
    statLabel: 'tempo médio de resposta',
    delay: 0,
  },
  {
    icon: 'ri-notification-3-line',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-500',
    title: 'Time comercial afogado em mensagens',
    text: '100, 200 mensagens por dia. Metade são as mesmas perguntas: preço, prazo, especificação. Seu vendedor gasta 80% do tempo repetindo informação em vez de fechar negócio.',
    stat: '80%',
    statLabel: 'do tempo em tarefas repetitivas',
    delay: 100,
  },
  {
    icon: 'ri-moon-line',
    iconBg: 'bg-indigo-50',
    iconColor: 'text-indigo-500',
    title: 'Fora do horário = vendas perdidas',
    text: '70% das mensagens chegam fora do horário comercial ou no fim de semana. São leads quentes que não vão esperar até segunda-feira.',
    stat: '70%',
    statLabel: 'dos leads chegam fora do horário',
    delay: 200,
  },
];

export default function Problem() {
  const { ref, visible } = useScrollAnimation(0.1);

  return (
    <section id="problem" className="bg-white py-24 lg:py-32 px-6">
      <div className="max-w-6xl mx-auto" ref={ref}>
        {/* Section label */}
        <div
          className={`flex justify-center mb-5 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <span className="font-b2bbody text-xs font-semibold tracking-widest uppercase border border-coral/30 text-coral rounded-full px-4 py-1.5">
            O Problema
          </span>
        </div>

        {/* Title */}
        <div
          className={`text-center mb-4 transition-all duration-700 delay-75 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <h2 className="font-b2b text-3xl sm:text-4xl lg:text-[2.75rem] font-bold text-navy leading-tight">
            Você está perdendo vendas de{' '}
            <span className="text-coral">alto ticket</span> todos os dias
          </h2>
        </div>

        <div
          className={`text-center mb-14 transition-all duration-700 delay-150 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="font-b2bbody text-gray-500 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            Enquanto você lê isso, um lead quente está esperando resposta no seu WhatsApp.
            E o concorrente está respondendo.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {painCards.map((card) => (
            <div
              key={card.title}
              className={`group bg-white border border-gray-100 rounded-2xl p-7 cursor-default transition-all duration-700 hover:-translate-y-1 hover:border-coral/20 hover:shadow-lg ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: visible ? `${card.delay + 200}ms` : '0ms' }}
            >
              {/* Icon */}
              <div className={`w-12 h-12 ${card.iconBg} rounded-xl flex items-center justify-center mb-5`}>
                <i className={`${card.icon} ${card.iconColor} text-xl`} />
              </div>

              {/* Stat callout */}
              <div className="flex items-baseline gap-1.5 mb-3">
                <span className="font-b2b text-3xl font-extrabold text-navy">{card.stat}</span>
                <span className="font-b2bbody text-xs text-gray-400 leading-snug max-w-[120px]">
                  {card.statLabel}
                </span>
              </div>

              <h3 className="font-b2b text-lg font-bold text-navy mb-3 leading-snug">
                {card.title}
              </h3>
              <p className="font-b2bbody text-gray-500 text-sm leading-relaxed">
                {card.text}
              </p>
            </div>
          ))}
        </div>

        {/* Impact phrase */}
        <div
          className={`mt-14 text-center transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ transitionDelay: visible ? '550ms' : '0ms' }}
        >
          <div className="inline-flex items-center gap-3 bg-coral/5 border border-coral/20 rounded-2xl px-7 py-4">
            <i className="ri-alarm-warning-fill text-coral text-xl" />
            <p className="font-b2b text-coral font-bold text-base sm:text-lg">
              A cada minuto sem resposta, você entrega dinheiro para o concorrente.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}